/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/forms';
import * as i2 from '../../../common/formInput/formInput.component.ngfactory';
import * as i3 from '../../../../../../app/components/common/formInput/formInput.component';
import * as i4 from '@angular/common';
import * as i5 from './clearance-option/clearance-option.component.ngfactory';
import * as i6 from '../../../../../../app/components/calculator/cards/currency-card/clearance-option/clearance-option.component';
import * as i7 from '../../../../../../app/common/pipes/firstKeyPipe';
import * as i8 from '../../../../../../app/components/calculator/cards/currency-card/clearance-fee-card.component';
import * as i9 from '../../../../../../app/common/directives/click-outside.directive';
import * as i10 from 'ngx-bootstrap/dropdown/bs-dropdown.state';
import * as i11 from 'ngx-bootstrap/dropdown/bs-dropdown.directive';
import * as i12 from 'ngx-bootstrap/component-loader/component-loader.factory';
import * as i13 from 'ngx-bootstrap/dropdown/bs-dropdown.config';
import * as i14 from 'ngx-bootstrap/dropdown/bs-dropdown-toggle.directive';
import * as i15 from 'ngx-bootstrap/dropdown/bs-dropdown-menu.directive';
import * as i16 from '../../../../../../app/services/orderService';
const styles_ClearanceFeeCardComponent:any[] = ([] as any[]);
export const RenderType_ClearanceFeeCardComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ClearanceFeeCardComponent,data:{}});
function View_ClearanceFeeCardComponent_1(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),5,'div',[['class',
      'edited']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          2,'span',([] as any[]),(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'i',[['class',
          'material-icons']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),['mode_edit'])),(_l()(),i0.ɵted((null as any),
          [' ']))],(null as any),(null as any));
}
function View_ClearanceFeeCardComponent_2(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'span',[['class',
      'percent']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' (','%) '])),i0.ɵppd(2)],(null as any),(_ck,
      _v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵunv(_v,1,0,_ck(_v,2,0,i0.ɵnov((<any>_v.parent),0),_co.percentFee,
        '.2-2'));
    _ck(_v,1,0,currVal_0);
  });
}
function View_ClearanceFeeCardComponent_3(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),3,'option',([] as any[]),
      [[8,'selected',0]],(null as any),(null as any),(null as any),(null as any))),
      i0.ɵdid(147456,(null as any),0,i1.NgSelectOption,[i0.ElementRef,i0.Renderer2,
          [2,i1.SelectControlValueAccessor]],{ngValue:[0,'ngValue']},(null as any)),
      i0.ɵdid(147456,(null as any),0,i1.ɵq,[i0.ElementRef,i0.Renderer2,[8,(null as any)]],
          {ngValue:[0,'ngValue']},(null as any)),(_l()(),i0.ɵted((null as any),[' ',
          ' ']))],(_ck,_v) => {
    const currVal_1:any = _v.context.$implicit;
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = _v.context.$implicit;
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = (_v.context.$implicit.Id == ((_co.currentCurrencyCode == null)? (null as any): _co.currentCurrencyCode.Id));
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = _v.context.$implicit.Name;
    _ck(_v,3,0,currVal_3);
  });
}
function View_ClearanceFeeCardComponent_4(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),2,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' ',' '])),i0.ɵppd(2)],(null as any),(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = i0.ɵunv(_v,1,0,_ck(_v,2,0,i0.ɵnov((<any>_v.parent),0),_co.total,
        '.2-2'));
    _ck(_v,1,0,currVal_0);
  });
}
function View_ClearanceFeeCardComponent_5(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',([] as any[]),
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' ',' ']))],(null as any),(_ck,_v) => {
    const currVal_0:any = 0;
    _ck(_v,1,0,currVal_0);
  });
}
function View_ClearanceFeeCardComponent_7(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'help-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' Total is required. ']))],(null as any),(null as any));
}
function View_ClearanceFeeCardComponent_8(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'span',[['class',
      'help-block']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' Total should contain only digits. ']))],(null as any),
      (null as any));
}
function View_ClearanceFeeCardComponent_6(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),17,'form-input',
      [['name','total'],['pattern','^[0-9]+([,.][0-9]{1,2})?$'],['required',''],['type',
          'number']],[[1,'required',0],[1,'pattern',0],[2,'ng-untouched',(null as any)],
          [2,'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
              (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'input']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:any = _v.component;
        if (('ngModelChange' === en)) {
          const pd_0:any = ((<any>(_co.total = $event)) !== false);
          ad = (pd_0 && ad);
        }
        if (('input' === en)) {
          const pd_1:any = ((<any>_co.handleTotalChange($event.target.value)) !== false);
          ad = (pd_1 && ad);
        }
        return ad;
      },i2.View_FormInputComponent_0,i2.RenderType_FormInputComponent)),i0.ɵdid(16384,
      (null as any),0,i1.RequiredValidator,([] as any[]),{required:[0,'required']},
      (null as any)),i0.ɵdid(540672,(null as any),0,i1.PatternValidator,([] as any[]),
      {pattern:[0,'pattern']},(null as any)),i0.ɵprd(1024,(null as any),i1.NG_VALIDATORS,
      (p0_0:any,p1_0:any) => {
        return [p0_0,p1_0];
      },[i1.RequiredValidator,i1.PatternValidator]),i0.ɵdid(4308992,[['totalModal',
      4]],0,i3.FormInputComponent,[[2,i1.NG_VALIDATORS],[2,i1.NG_ASYNC_VALIDATORS]],
      {type:[0,'type'],name:[1,'name'],form:[2,'form']},(null as any)),i0.ɵprd(1024,
      (null as any),i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
        return [p0_0];
      },[i3.FormInputComponent]),i0.ɵdid(671744,(null as any),0,i1.NgModel,[[2,i1.ControlContainer],
      [2,i1.NG_VALIDATORS],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],{name:[0,'name'],
      model:[1,'model']},{update:'ngModelChange'}),i0.ɵprd(2048,(null as any),i1.NgControl,
      (null as any),[i1.NgModel]),i0.ɵdid(16384,(null as any),0,i1.NgControlStatus,
      [i1.NgControl],(null as any),(null as any)),(_l()(),i0.ɵted(0,[' '])),(_l()(),
      i0.ɵand(16777216,(null as any),0,2,(null as any),View_ClearanceFeeCardComponent_7)),
      i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),i0.ɵppd(1),(_l()(),i0.ɵted(0,[' '])),(_l()(),i0.ɵand(16777216,
          (null as any),0,2,(null as any),View_ClearanceFeeCardComponent_8)),i0.ɵdid(16384,
          (null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),i0.ɵppd(1),(_l()(),i0.ɵted(0,[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_9:any = '';
    _ck(_v,1,0,currVal_9);
    const currVal_10:any = '^[0-9]+([,.][0-9]{1,2})?$';
    _ck(_v,2,0,currVal_10);
    const currVal_11:any = 'number';
    const currVal_12:any = 'total';
    const currVal_13:any = i0.ɵnov((<any>_v.parent),49);
    _ck(_v,4,0,currVal_11,currVal_12,currVal_13);
    const currVal_14:any = 'total';
    const currVal_15:any = _co.total;
    _ck(_v,6,0,currVal_14,currVal_15);
    const currVal_16:any = (i0.ɵunv(_v,11,0,_ck(_v,12,0,i0.ɵnov((<any>_v.parent),1),
        i0.ɵnov(_v,4).model.errors)) == 'required');
    _ck(_v,11,0,currVal_16);
    const currVal_17:any = ((i0.ɵunv(_v,15,0,_ck(_v,16,0,i0.ɵnov((<any>_v.parent),
        1),i0.ɵnov(_v,4).model.errors)) == 'pattern') && _co.localTotal);
    _ck(_v,15,0,currVal_17);
  },(_ck,_v) => {
    const currVal_0:any = (i0.ɵnov(_v,1).required? '': (null as any));
    const currVal_1:any = (i0.ɵnov(_v,2).pattern? i0.ɵnov(_v,2).pattern: (null as any));
    const currVal_2:any = i0.ɵnov(_v,8).ngClassUntouched;
    const currVal_3:any = i0.ɵnov(_v,8).ngClassTouched;
    const currVal_4:any = i0.ɵnov(_v,8).ngClassPristine;
    const currVal_5:any = i0.ɵnov(_v,8).ngClassDirty;
    const currVal_6:any = i0.ɵnov(_v,8).ngClassValid;
    const currVal_7:any = i0.ɵnov(_v,8).ngClassInvalid;
    const currVal_8:any = i0.ɵnov(_v,8).ngClassPending;
    _ck(_v,0,0,currVal_0,currVal_1,currVal_2,currVal_3,currVal_4,currVal_5,currVal_6,
        currVal_7,currVal_8);
  });
}
function View_ClearanceFeeCardComponent_10(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,(null as any),
      (null as any),(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          1,'clearance-option',([] as any[]),(null as any),[[(null as any),'valueChanged']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:any = _v.component;
            if (('valueChanged' === en)) {
              const pd_0:any = ((<any>_co.recalculateTotal(true)) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },i5.View_ClearanceOptionComponent_0,i5.RenderType_ClearanceOptionComponent)),
      i0.ɵdid(49152,[[3,4],['clearanceOption',4]],0,i6.ClearanceOptionComponent,([] as any[]),
          {orderItem:[0,'orderItem'],form:[1,'form'],index:[2,'index']},{valueChanged:'valueChanged'}),
      (_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit;
    const currVal_1:any = i0.ɵnov((<any>(<any>_v.parent).parent),49);
    const currVal_2:any = (_v.context.index + 1);
    _ck(_v,3,0,currVal_0,currVal_1,currVal_2);
  },(null as any));
}
function View_ClearanceFeeCardComponent_9(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),4,'ul',[['aria-labelledby',
      'basic-link'],['class','dropdown-menu'],['id','dropdown-basic'],['role','menu']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),(_l()(),
      i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
      1,(null as any),View_ClearanceFeeCardComponent_10)),i0.ɵdid(802816,(null as any),
      0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],{ngForOf:[0,
          'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,_v) => {
    var _co:any = _v.component;
    const currVal_0:any = _co.order.OrderItems;
    _ck(_v,3,0,currVal_0);
  },(null as any));
}
export function View_ClearanceFeeCardComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵpid(0,i4.DecimalPipe,[i0.LOCALE_ID]),i0.ɵpid(0,i7.FirstKeyPipe,
      ([] as any[])),i0.ɵqud(402653184,1,{dropdownDirective:0}),i0.ɵqud(402653184,
      2,{optionsFrom:0}),i0.ɵqud(671088640,3,{clearanceOptions:1}),(_l()(),i0.ɵeld(0,
      (null as any),(null as any),78,'div',[['class','text-center calc-tab small-tab margin-bottom-0']],
      (null as any),(null as any),(null as any),(null as any),(null as any))),i0.ɵdid(278528,
      (null as any),0,i4.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,
          i0.Renderer],{klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod({'red-shadow':0}),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          4,'div',[['class','position-relative']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵand(16777216,(null as any),(null as any),1,(null as any),View_ClearanceFeeCardComponent_1)),
      i0.ɵdid(16384,(null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,
          'ngIf']},(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),10,'div',[['class',
          'row']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          7,'div',[['class','col-md-12']],(null as any),(null as any),(null as any),
          (null as any),(null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),4,'div',[['class','title']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' ',' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ClearanceFeeCardComponent_2)),i0.ɵdid(16384,(null as any),0,i4.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵeld(0,(null as any),(null as any),55,'div',[['class','row']],(null as any),
              (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),52,'div',([] as any[]),
          (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),
          49,'div',[['class','cost']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,
          (null as any),(null as any),12,'div',[['class','col-md-6 currency']],(null as any),
          (null as any),(null as any),(null as any),(null as any))),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(0,(null as any),(null as any),9,'select',[['class',
          'form-control'],['name','currency']],[[2,'ng-untouched',(null as any)],[2,
          'ng-touched',(null as any)],[2,'ng-pristine',(null as any)],[2,'ng-dirty',
          (null as any)],[2,'ng-valid',(null as any)],[2,'ng-invalid',(null as any)],
          [2,'ng-pending',(null as any)]],[[(null as any),'ngModelChange'],[(null as any),
          'change'],[(null as any),'blur']],(_v,en,$event) => {
        var ad:boolean = true;
        var _co:i8.ClearanceFeeCardComponent = _v.component;
        if (('change' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,36).onChange($event.target.value)) !== false);
          ad = (pd_0 && ad);
        }
        if (('blur' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,36).onTouched()) !== false);
          ad = (pd_1 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_2:any = ((<any>(_co.currentCurrencyCode = $event)) !== false);
          ad = (pd_2 && ad);
        }
        if (('ngModelChange' === en)) {
          const pd_3:any = ((<any>_co.convert($event)) !== false);
          ad = (pd_3 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.SelectControlValueAccessor,
          [i0.Renderer2,i0.ElementRef],(null as any),(null as any)),i0.ɵprd(1024,(null as any),
          i1.NG_VALUE_ACCESSOR,(p0_0:any) => {
            return [p0_0];
          },[i1.SelectControlValueAccessor]),i0.ɵdid(671744,(null as any),0,i1.NgModel,
          [[8,(null as any)],[8,(null as any)],[8,(null as any)],[2,i1.NG_VALUE_ACCESSOR]],
          {name:[0,'name'],isDisabled:[1,'isDisabled'],model:[2,'model']},{update:'ngModelChange'}),
      i0.ɵprd(2048,(null as any),i1.NgControl,(null as any),[i1.NgModel]),i0.ɵdid(16384,
          (null as any),0,i1.NgControlStatus,[i1.NgControl],(null as any),(null as any)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ClearanceFeeCardComponent_3)),i0.ɵdid(802816,
          (null as any),0,i4.NgForOf,[i0.ViewContainerRef,i0.TemplateRef,i0.IterableDiffers],
          {ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),32,'form',[['class','width-50-pct padding-left-10'],
          ['novalidate','']],[[2,'ng-untouched',(null as any)],[2,'ng-touched',(null as any)],
          [2,'ng-pristine',(null as any)],[2,'ng-dirty',(null as any)],[2,'ng-valid',
              (null as any)],[2,'ng-invalid',(null as any)],[2,'ng-pending',(null as any)]],
          [[(null as any),'submit'],[(null as any),'reset']],(_v,en,$event) => {
            var ad:boolean = true;
            if (('submit' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,49).onSubmit($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('reset' === en)) {
              const pd_1:any = ((<any>i0.ɵnov(_v,49).onReset()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i1.ɵbf,([] as any[]),
          (null as any),(null as any)),i0.ɵdid(16384,[[2,4],['optionsFrom',4]],0,i1.NgForm,
          [[8,(null as any)],[8,(null as any)]],(null as any),(null as any)),i0.ɵprd(2048,
          (null as any),i1.ControlContainer,(null as any),[i1.NgForm]),i0.ɵdid(16384,
          (null as any),0,i1.NgControlStatusGroup,[i1.ControlContainer],(null as any),
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵeld(0,(null as any),
          (null as any),25,'div',[['class','cost-dropdown text-center']],(null as any),
          [[(null as any),'clickOutside'],['document','click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i8.ClearanceFeeCardComponent = _v.component;
            if (('document:click' === en)) {
              const pd_0:any = ((<any>i0.ɵnov(_v,54).onDocumentClick($event)) !== false);
              ad = (pd_0 && ad);
            }
            if (('clickOutside' === en)) {
              const pd_1:any = ((<any>_co.hideDropDown()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(16384,(null as any),0,i9.ClickOutsideDirective,
          [i0.ElementRef],(null as any),{clickOutside:'clickOutside'}),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵeld(16777216,(null as any),(null as any),21,'div',[['class',
          'bs-dropdown'],['dropdown','']],[[2,'dropup',(null as any)],[2,'open',(null as any)],
          [2,'show',(null as any)]],[[(null as any),'onHidden'],[(null as any),'onShown']],
          (_v,en,$event) => {
            var ad:boolean = true;
            var _co:i8.ClearanceFeeCardComponent = _v.component;
            if (('onHidden' === en)) {
              const pd_0:any = ((<any>_co.onDropDownHidden()) !== false);
              ad = (pd_0 && ad);
            }
            if (('onShown' === en)) {
              const pd_1:any = ((<any>_co.onDropDownShown()) !== false);
              ad = (pd_1 && ad);
            }
            return ad;
          },(null as any),(null as any))),i0.ɵdid(278528,(null as any),0,i4.NgClass,
          [i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],{klass:[0,
              'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod({'disabled':0}),
      i0.ɵprd(512,(null as any),i10.BsDropdownState,i10.BsDropdownState,([] as any[])),
      i0.ɵdid(212992,[[1,4],['dropdownRef',4]],0,i11.BsDropdownDirective,[i0.ElementRef,
          i0.Renderer,i0.ViewContainerRef,i12.ComponentLoaderFactory,i13.BsDropdownConfig,
          i10.BsDropdownState],{autoClose:[0,'autoClose'],isDisabled:[1,'isDisabled']},
          {onShown:'onShown',onHidden:'onHidden'}),(_l()(),i0.ɵted((null as any),[' '])),
      (_l()(),i0.ɵeld(0,(null as any),(null as any),8,'a',[['aria-controls','dropdown-basic'],
          ['class',''],['dropdownToggle',''],['role','button']],[[8,'hidden',0],[1,
          'aria-haspopup',0],[1,'disabled',0],[1,'aria-expanded',0]],[[(null as any),
          'click'],['document','click'],[(null as any),'keyup.esc']],(_v,en,$event) => {
        var ad:boolean = true;
        if (('click' === en)) {
          const pd_0:any = ((<any>i0.ɵnov(_v,63).onClick()) !== false);
          ad = (pd_0 && ad);
        }
        if (('document:click' === en)) {
          const pd_1:any = ((<any>i0.ɵnov(_v,63).onDocumentClick($event)) !== false);
          ad = (pd_1 && ad);
        }
        if (('keyup.esc' === en)) {
          const pd_2:any = ((<any>i0.ɵnov(_v,63).onEsc()) !== false);
          ad = (pd_2 && ad);
        }
        return ad;
      },(null as any),(null as any))),i0.ɵdid(147456,(null as any),0,i14.BsDropdownToggleDirective,
          [i10.BsDropdownState,i0.ElementRef],(null as any),(null as any)),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ClearanceFeeCardComponent_4)),i0.ɵdid(16384,(null as any),
          0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),
      (_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),
          (null as any),1,(null as any),View_ClearanceFeeCardComponent_5)),i0.ɵdid(16384,
          (null as any),0,i4.NgIf,[i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},
          (null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),
          [' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),1,(null as any),
          View_ClearanceFeeCardComponent_6)),i0.ɵdid(16384,(null as any),0,i4.NgIf,
          [i0.ViewContainerRef,i0.TemplateRef],{ngIf:[0,'ngIf']},(null as any)),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵand(16777216,(null as any),(null as any),
          1,(null as any),View_ClearanceFeeCardComponent_9)),i0.ɵdid(16384,(null as any),
          0,i15.BsDropdownMenuDirective,[i10.BsDropdownState,i0.ViewContainerRef,i0.TemplateRef],
          (null as any),(null as any)),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' '])),(_l()(),
          i0.ɵted((null as any),[' '])),(_l()(),i0.ɵted((null as any),[' ']))],(_ck,
      _v) => {
    var _co:i8.ClearanceFeeCardComponent = _v.component;
    const currVal_0:any = 'text-center calc-tab small-tab margin-bottom-0';
    const currVal_1:any = _ck(_v,7,0,(_co.showHighlight && (_co.isChanging == false)));
    _ck(_v,6,0,currVal_0,currVal_1);
    const currVal_2:any = _co.calculatorHelper.IsBBFeeEdited(_co.order);
    _ck(_v,12,0,currVal_2);
    const currVal_4:any = _co.percentFee;
    _ck(_v,22,0,currVal_4);
    const currVal_12:any = 'currency';
    const currVal_13:any = _co.disableChanges;
    const currVal_14:any = _co.currentCurrencyCode;
    _ck(_v,38,0,currVal_12,currVal_13,currVal_14);
    const currVal_15:any = _co.canadianCurrencyCodes;
    _ck(_v,43,0,currVal_15);
    const currVal_26:any = 'bs-dropdown';
    const currVal_27:any = _ck(_v,58,0,_co.disableChanges);
    _ck(_v,57,0,currVal_26,currVal_27);
    const currVal_28:any = false;
    const currVal_29:any = _co.disableChanges;
    _ck(_v,60,0,currVal_28,currVal_29);
    const currVal_34:any = ((_co.total != (null as any)) && (_co.total != 0));
    _ck(_v,66,0,currVal_34);
    const currVal_35:any = (_co.total == 0);
    _ck(_v,69,0,currVal_35);
    const currVal_36:any = _co.isDropDownShown;
    _ck(_v,73,0,currVal_36);
  },(_ck,_v) => {
    var _co:i8.ClearanceFeeCardComponent = _v.component;
    const currVal_3:any = _co.title;
    _ck(_v,20,0,currVal_3);
    const currVal_5:any = i0.ɵnov(_v,40).ngClassUntouched;
    const currVal_6:any = i0.ɵnov(_v,40).ngClassTouched;
    const currVal_7:any = i0.ɵnov(_v,40).ngClassPristine;
    const currVal_8:any = i0.ɵnov(_v,40).ngClassDirty;
    const currVal_9:any = i0.ɵnov(_v,40).ngClassValid;
    const currVal_10:any = i0.ɵnov(_v,40).ngClassInvalid;
    const currVal_11:any = i0.ɵnov(_v,40).ngClassPending;
    _ck(_v,35,0,currVal_5,currVal_6,currVal_7,currVal_8,currVal_9,currVal_10,currVal_11);
    const currVal_16:any = i0.ɵnov(_v,51).ngClassUntouched;
    const currVal_17:any = i0.ɵnov(_v,51).ngClassTouched;
    const currVal_18:any = i0.ɵnov(_v,51).ngClassPristine;
    const currVal_19:any = i0.ɵnov(_v,51).ngClassDirty;
    const currVal_20:any = i0.ɵnov(_v,51).ngClassValid;
    const currVal_21:any = i0.ɵnov(_v,51).ngClassInvalid;
    const currVal_22:any = i0.ɵnov(_v,51).ngClassPending;
    _ck(_v,47,0,currVal_16,currVal_17,currVal_18,currVal_19,currVal_20,currVal_21,
        currVal_22);
    const currVal_23:any = i0.ɵnov(_v,60).dropup;
    const currVal_24:any = i0.ɵnov(_v,60).isOpen;
    const currVal_25:any = (i0.ɵnov(_v,60).isOpen && i0.ɵnov(_v,60).isBs4);
    _ck(_v,56,0,currVal_23,currVal_24,currVal_25);
    const currVal_30:any = _co.isDropDownShown;
    const currVal_31:any = true;
    const currVal_32:any = i0.ɵnov(_v,63).isDisabled;
    const currVal_33:any = i0.ɵnov(_v,63).isOpen;
    _ck(_v,62,0,currVal_30,currVal_31,currVal_32,currVal_33);
  });
}
export function View_ClearanceFeeCardComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,(null as any),(null as any),1,'clearance-fee-card',
      ([] as any[]),(null as any),(null as any),(null as any),View_ClearanceFeeCardComponent_0,
      RenderType_ClearanceFeeCardComponent)),i0.ɵdid(4767744,(null as any),0,i8.ClearanceFeeCardComponent,
      [i16.OrderService],(null as any),(null as any))],(null as any),(null as any));
}
export const ClearanceFeeCardComponentNgFactory:i0.ComponentFactory<i8.ClearanceFeeCardComponent> = i0.ɵccf('clearance-fee-card',
    i8.ClearanceFeeCardComponent,View_ClearanceFeeCardComponent_Host_0,{order:'order',
        title:'title',total:'total',percentFee:'percentFee',canadianCurrencyCodes:'canadianCurrencyCodes',
        defaultCurrencyCode:'defaultCurrencyCode',disableChanges:'disableChanges',
        showHighlight:'showHighlight'},{currencyChanged:'currencyChanged',orderChangeEmit:'orderChangeEmit',
        aaFeeChangeEmit:'aaFeeChangeEmit'},([] as any[]));
//# sourceMappingURL=data:application/json;base64,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



// WEBPACK FOOTER //
// ./compiled/app/components/calculator/cards/currency-card/clearance-fee-card.component.ngfactory.ts